import { scroller } from 'react-scroll'

function scrollTo(id, scrollOffset=-70, scrollDuration=500) {
  if (typeof document !== 'undefined') {
    scroller.scrollTo(id, {
      duration: scrollDuration,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: scrollOffset
    });

    // Optionally wait for scroll animation to complete before focusing
    setTimeout(() => {
      const target = document.getElementById(id);
      if (target) {
        // Ensure it's focusable (especially if it's a div or heading)
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }
    }, scrollDuration + 20); // buffer time after scroll finishes
  }
}

export default {
  scrollTo
}
